/** Balance returned by charging endpoints (see ClientCredits on the server). */
export type ClientCredits = {
  monthlyCredits: number;
  bonusCredits: number;
};

export const useUser = () => {
  const user = useState<any>("user", () => null);

  // fetch user data
  const fetchUser = async () => {
    const { data } = await useFetch("/api/user", {
      key: "userData",
    });

    user.value = data.value;
  };
  const clearUser = () => {
    user.value = null;
  };

  // Apply the balance a charging endpoint sent back, so every credit display
  // updates without re-fetching the user. Ignores missing/malformed values.
  const applyCredits = (credits?: Partial<ClientCredits> | null) => {
    const monthly = Number(credits?.monthlyCredits);
    const bonus = Number(credits?.bonusCredits);
    if (!user.value || !Number.isFinite(monthly) || !Number.isFinite(bonus)) {
      return;
    }
    user.value = { ...user.value, monthly_limit: monthly, bonus_limit: bonus };
  };

  return {
    user,
    fetchUser,
    clearUser,
    applyCredits,
  };
};
